import type { ProjectPackageJson } from '@cli-types/next-adapter/utils.js'

export function hasCompatibleMarkdownItDependency(pkg: ProjectPackageJson | null): boolean {
  const spec = pkg?.dependencies?.['markdown-it']
  return typeof spec === 'string' && /^(?:workspace:|link:|file:|portal:|\^?13\.|~13\.)/.test(spec)
}
